/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Document_Number_SeriesInputs */

const en_reference_dataset_document_number_series = /** @type {(inputs: Reference_Dataset_Document_Number_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number series of sales documents`)
};

/**
* | output |
* | --- |
* | "Number series of sales documents" |
*
* @param {Reference_Dataset_Document_Number_SeriesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_document_number_series = /** @type {((inputs?: Reference_Dataset_Document_Number_SeriesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Document_Number_SeriesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_document_number_series(inputs)
});